exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-box.style5>i[data-v-35a1f618]{background:#9f4378}.icon-box.style5[data-v-35a1f618]{background:#f5f5f5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35a1f618","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/forms/HelpTab.vue
// module id = 348
// module chunks = 0